/**
 * Person class.
 */
export class Person {
  /**
   * Constructor for Person class.
   *
   * @param {number} personId - The unique id of the person.
   * @param {string} name - The person's name.
   * @param {string} firstName - The person's first name.
   * @param {string} birthDate - The person's birth date.
   * @param {string} gender - The person's gender.
   * @param {string} company - The company name.
   * @param {string} uid - A unique company uid.
   * @param {string} street - Street name of the company.
   * @param {string} streetNumber - Street number of the company.
   * @param {string} addition - An addition to the company address.
   * @param {string} postOffice - The post office of the company.
   * @param {string} postcode - The postcode of the company.
   * @param {string} location - The location of the company.
   * @param {string} careOf - The name of a responsible person to care of.
   * @param {string} faxNumber - The person's fax number.
   * @param {string} email - The person's email address.
   * @param {string} phoneNumber - The person's phone number.
   * @param {string} mobileNumber - The person's mobile number.
   */
  constructor(
    personId,
    name,
    firstName,
    birthDate,
    gender,
    company,
    uid,
    street,
    streetNumber,
    addition,
    postOffice,
    postcode,
    location,
    careOf,
    faxNumber,
    email,
    phoneNumber,
    mobileNumber
  ) {
    this.id = personId;
    this.officialName = name;
    this.firstNames = firstName;
    this.birthDate = birthDate;
    this.gender = gender;
    this.organisation = {
      name: company,
      uid: uid,
      contactInformation: {
        street: street,
        houseNumber: streetNumber,
        addition: addition,
        postOffice: postOffice,
        swissZip: postcode,
        town: location,
        careOf: careOf,
        fax: faxNumber,
        mail: email,
        telephone: phoneNumber
      }
    };
    this.contactInformation = {
      mobileNumber: mobileNumber
    };
  }
}
